import React from "react";
import classNames from "classnames";

import ProfileIcon from "$components/profile-icon";
import { formatDate, SLASH_DATE_FORMAT } from "$utils/date-helpers";

const isOverdue = (dueDate, status) =>
    status === "open" && dueDate && new Date(dueDate) < new Date();

const STATUS_BADGE = { open: "badge-secondary", complete: "badge-success", cancelled: "badge-danger" };
const STATUS_LABELS = { open: "Open", complete: "Complete", cancelled: "Cancelled" };

export const buildActionItemColumns = ({ onMarkComplete, onEdit }) => [
    {
        Header: () => "Task",
        accessorKey: "commitmentText",
        id: "commitmentText",
        size: 280,
        Cell: ({ value }) => <span>{value}</span>,
    },
    {
        Header: () => "Assignee",
        accessorKey: "assignedToUserName",
        id: "assignedToUserName",
        size: 160,
        Cell: ({ value }) => value ? (
            <div className="action-item__assignee-cell">
                <ProfileIcon name={value} modifierClassNames={["-small"]} />
                <span className="txt -small">{value}</span>
            </div>
        ) : null,
    },
    {
        Header: () => "Due Date",
        accessorKey: "dueDate",
        id: "dueDate",
        size: 110,
        Cell: ({ data, value }) => {
            if (!value) return null;
            const overdue = isOverdue(value, data.status);
            return (
                <span className={classNames("txt -small", { "-error": overdue, "-light": !overdue })}>
                    {overdue && "⚠ "}
                    {formatDate(value, SLASH_DATE_FORMAT)}
                </span>
            );
        },
    },
    {
        Header: () => "Status",
        accessorKey: "status",
        id: "status",
        size: 100,
        Cell: ({ value }) => (
            <span className={`badge ${STATUS_BADGE[value] || "badge-secondary"}`}>
                {STATUS_LABELS[value] || value}
            </span>
        ),
    },
    {
        Header: () => "",
        accessorKey: "id",
        id: "actions",
        enableSorting: false,
        size: 180,
        Cell: ({ data }) => data.status === "open" ? (
            <div className="action-item__actions-cell" onClick={(e) => e.stopPropagation()}>
                <button
                    className="button -secondary -small"
                    onClick={() => onMarkComplete(data)}
                >
                    Mark Complete
                </button>
                <button
                    className="button -small -outline"
                    onClick={() => onEdit(data)}
                >
                    Edit
                </button>
            </div>
        ) : null,
    },
];
